import { render, staticRenderFns } from "./CardDatatable.vue?vue&type=template&id=5bc2435c&scoped=true"
import script from "./CardDatatable.vue?vue&type=script&lang=js"
export * from "./CardDatatable.vue?vue&type=script&lang=js"
import style0 from "./CardDatatable.vue?vue&type=style&index=0&id=5bc2435c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2435c",
  null
  
)

export default component.exports